<template>
  <!-- 用电记录 -->
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="分支箱资产码">
        <el-input placeholder="请输入资产码" v-model="filter.assets_code" clearable></el-input>
      </el-form-item>
      <el-form-item label="分支箱名">
        <el-input placeholder="请输入分支箱名称" v-model="filter.branch_box_name" clearable></el-input>
      </el-form-item>
      <el-form-item label="站点名">
        <el-input placeholder="请输入站点名" v-model="filter.site_name" clearable></el-input>
      </el-form-item>
      <el-form-item label="通道">
        <el-input placeholder="通道号" v-model="filter.gunNo" clearable @input="handleInput"
          style="width: 120px"></el-input>
      </el-form-item>
      <el-form-item label="订单编号">
        <el-input placeholder="请输入订单编号" v-model="filter.tradeNo" clearable></el-input>
      </el-form-item>
      <el-form-item label="时间范围">
        <el-date-picker v-model="filter.dateRange" type="datetimerange" range-separator="至" start-placeholder="开始时间"
          end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" clearable></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <!-- <el-button   icon="el-icon-plus" type="success"
          @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button> -->
      </el-form-item>
    </el-form>


    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
      <el-table-column label="站点名" prop="site_name" align="center"></el-table-column>
      <el-table-column label="分支箱名" prop="branch_box_name" align="center"></el-table-column>
      <el-table-column label="分支箱资产码" prop="asset_code" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="通道" prop="gunNo" width="60" align="center"></el-table-column>
      <el-table-column label="订单编号" prop="tradeNo" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="电量(度)" width="90" align="center">
        <template slot-scope="{ row }">
          {{ formatElect(row.totalElect) }}
        </template>
      </el-table-column>
      <el-table-column label="电费(元)" align="center" width="90">
        <template slot-scope="{ row }">
          {{ formatCost(row.totalPowerCost) }}
        </template>
      </el-table-column>
      <el-table-column label="服务费(元)" align="center" width="100">
        <template slot-scope="{ row }">
          {{ formatCost(row.totalServCost) }}
        </template>
      </el-table-column>
      <el-table-column label="停止原因" prop="reason_desc" align="center" width="90px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="开始时间" prop="charge_start_time" align="center"></el-table-column>
      <el-table-column label="结束时间" prop="charge_end_time" align="center"></el-table-column>
      <el-table-column label="创建时间" prop="create_time" align="center"></el-table-column>
      <el-table-column :label="$t('publics.operation')" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onDetail(row)" v-permision_tjtf="'detail'">详情</el-button>
          <el-button type="text" @click="editPowerCurve(row)" v-permision_tjtf="'gl_quxian'">功率曲线</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <div class="statistic_left">
        <span class="sbox">
          总电量： <span class="bold ssuc">{{ totalElect }} 度</span>
        </span>
        <span class="sbox">
          总电费：<span class="bold sfail">{{ totalPowerCost }} 元</span>
        </span>
        <span class="sbox">
          总服务费：<span class="bold sinfo"> {{ totalServCost }} 元</span>
        </span>
        <span class="sbox">
          总用电时长：<span class="bold sreturn"> {{ totalUseElectTime }} h</span>
        </span>

        <!-- <el-descriptions :column="4" :border="true">
          <el-descriptions-item label="总电量：">
            <span style="color: green;">{{ totalElect }}度</span>
          </el-descriptions-item>
          <el-descriptions-item label="总电费：">
            <span style="color: red;">{{ totalPowerCost }}元</span>
          </el-descriptions-item>
          <el-descriptions-item label="总服务费：">
            <span style="color: blue;"> {{ totalServCost }}元</span>
          </el-descriptions-item>
          <el-descriptions-item label="总用电时长：">
            <span> {{ totalUseElectTime }} h</span>
          </el-descriptions-item>
        </el-descriptions> -->
      </div>
      <el-pagination background layout="sizes,total,prev,pager,next,jumper" :total="pageParams.total"
        :page-size="pageParams.limit" :page-sizes="[5, 10, 50, 100, 500, 1000]" :current-page="pageParams.page"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>

    <el-dialog :visible.sync="detailVisible" title="用电记录详情" width="1000px" class="detail-dialog"
      :close-on-click-modal="false">
      <el-row type="flex" justify="center">
        <el-col :span="24">
          <el-form label-position="right" label-width="120px" :model="detailForm" ref="detailForm">
            <el-row :gutter="20">
              <!-- 第一列 -->
              <el-col :span="12">
                <el-form-item label="平台交易流水号" prop="preTradeNo">
                  <el-input v-model="detailForm.preTradeNo" readonly disabled />
                </el-form-item>
                <el-form-item label="资产码" prop="asset_code">
                  <el-input v-model="detailForm.asset_code" readonly disabled />
                </el-form-item>
                <el-form-item label="枪号" prop="gunNo">
                  <el-input v-model="detailForm.gunNo" readonly disabled />
                </el-form-item>

                <el-form-item label="计量计费类型" prop="timeDivType">
                  <el-input v-model="detailForm.timeDivTypeText" readonly disabled />
                </el-form-item>

                <el-form-item label="开始充电时间" prop="charge_start_time">
                  <el-input v-model="detailForm.charge_start_time" readonly disabled />
                </el-form-item>

                <el-form-item label="结束充电时间" prop="charge_end_time">
                  <el-input v-model="detailForm.charge_end_time" readonly disabled />
                </el-form-item>

                <el-form-item label="启动时 SOC" prop="startSoc"> {{ detailForm.startSoc }}　<label>停止时 SOC</label>：{{
                  detailForm.endSoc }}　<label>待机耗电量</label>：{{ detailForm.standbyElect / 1000 }}度 </el-form-item>
              </el-col>

              <!-- 第二列 -->
              <el-col :span="12">
                <el-form-item label="设备交易流水号" prop="tradeNo">
                  <el-input v-model="detailForm.tradeNo" readonly disabled />
                </el-form-item>

                <el-form-item label="创建时间" prop="create_time">
                  <el-input v-model="detailForm.create_time" readonly disabled />
                </el-form-item>

                <el-form-item label="电表起始值" prop="sumStart">
                  <el-input v-model="detailForm.sumStartFormatted" readonly disabled />
                </el-form-item>

                <el-form-item label="电表终止值" prop="sumEnd">
                  <el-input v-model="detailForm.sumEndFormatted" readonly disabled />
                </el-form-item>

                <el-form-item label="电费模型编号" prop="eleModelId">
                  <el-input v-model="detailForm.eleModelId" readonly disabled />
                </el-form-item>

                <el-form-item label="服务费模型编号" prop="serModelId">
                  <el-input v-model="detailForm.serModelId" readonly disabled />
                </el-form-item>
                <el-form-item label="停止充电原因" prop="reason_desc">
                  <el-input v-model="detailForm.reason_desc" readonly disabled />
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 创建时间单独一行，因为可能是文本域 -->
          </el-form>
          <!-- 尖峰平谷电量电费表格 -->
          <div class="electricity-table-container" v-if="detailForm.electricityData">
            <h3 style="margin: 0px 0 10px 0; color: #409eff; text-align: center; display: block">尖峰平谷电量电费详情</h3>
            <el-table :data="electricityTableData" border size="medium" style="width: 100%; margin-bottom: 20px"
              :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
              <el-table-column prop="period" label="时段" align="center" width="120"></el-table-column>
              <el-table-column prop="electricity" label="电量(度)" align="center">
                <template slot-scope="{ row }">
                  <span :class="{ 'bold-text': row.period === '总计' }">{{ row.electricity }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="powerCost" label="电费(元)" align="center">
                <template slot-scope="{ row }">
                  <span :class="{ 'bold-text': row.period === '总计' }">{{ row.powerCost }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="servCost" label="服务费(元)" align="center">
                <template slot-scope="{ row }">
                  <span :class="{ 'bold-text': row.period === '总计' }">{{ row.servCost }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 功率曲线组件 -->
    <power-order-curve :show.sync="visible.curve" :params="modelParams" @confirm="confirmpowercurve"
      class="detail-dialog"></power-order-curve>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import { getDevUseElecPageList, GetDevUseElecStatisticInfo } from "@/api/dev_data_view"
import powercurve from "./components/power-order-curve.vue"

import { formatDate, formatReading } from "@/utils/tools.js";

import { mapGetters } from "vuex"
export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { "power-order-curve": powercurve, fileUpload },
  data() {
    return {
      detailForm: {
        electricityData: null // 存储电量电费数据
      },
      detailVisible: false,
      visible: {
        editGroup: false,
        curve: false
      },
      modelParams: {},
      tableData: [],
      dataStaticInfo: { totalElect: 0, totalPowerCost: 0, totalServCost: 0, totalUseTime: 0 },
      filter: {
        groupName: "",
        dateRange: [], // 使用一个数组来同时存储开始和结束时间
        assets_code: "",
        tradeNo: "",
        branch_box_name: "",
        site_name: "",
        gunNo: "" //通道
      },
      loading: false,
      isUpdate: true,
      gid: "" //街道id
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    // 计算表格数据
    electricityTableData() {
      if (!this.detailForm.electricityData) return []

      const data = this.detailForm.electricityData
      const tableData = [
        {
          period: "尖",
          electricity: data.sharpElect / 1000 || 0,
          powerCost: data.sharpPowerCost / 10000 || 0,
          servCost: data.sharpServCost / 10000 || 0,
          totalCost: (data.sharpPowerCost / 10000 || 0) + (data.sharpServCost / 10000 || 0)
        },
        {
          period: "峰",
          electricity: data.peakElect / 1000 || 0,
          powerCost: data.peakPowerCost / 10000 || 0,
          servCost: data.peakServCost / 10000 || 0,
          totalCost: (data.peakPowerCost / 10000 || 0) + (data.peakServCost / 10000 || 0)
        },
        {
          period: "平",
          electricity: data.flatElect / 1000 || 0,
          powerCost: data.flatPowerCost / 10000 || 0,
          servCost: data.flatServCost / 10000 || 0,
          totalCost: (data.flatPowerCost / 10000 || 0) + (data.flatServCost / 10000 || 0)
        },
        {
          period: "谷",
          electricity: data.valleyElect / 1000 || 0,
          powerCost: data.valleyPowerCost / 10000 || 0,
          servCost: data.valleyServCost / 10000 || 0,
          totalCost: (data.valleyPowerCost / 10000 || 0) + (data.valleyServCost / 10000 || 0)
        },
        {
          period: "总计",
          electricity: data.totalElect / 1000 || 0,
          powerCost: data.totalPowerCost / 10000 || 0,
          servCost: data.totalServCost / 10000 || 0,
          totalCost: (data.totalPowerCost / 10000 || 0) + (data.totalServCost / 10000 || 0)
        }
      ]

      return tableData
    },
    /**
     * 总的用电时长
     */
    totalUseElectTime() {
      return formatReading(this.dataStaticInfo.totalUseTime / 60 / 60)
    },
    /**
     * 总电量
     */
    totalElect() {
      return formatReading(this.dataStaticInfo.totalElect / 1000)
    },
    /**
     * 总电费
     */
    totalPowerCost() {
      return formatReading(this.dataStaticInfo.totalPowerCost / 10000)
    },
    /**
     * 总服务费
     */
    totalServCost() {
      return formatReading(this.dataStaticInfo.totalServCost / 10000)
    }
  },
  created() {
    this.initDefaultTimeRange()
    this.getData()
  },
  methods: {
    initDefaultTimeRange() {
      const now = new Date();
      // 当前时间（结束时间）
      const endDate = new Date(now);
      // 六个月前（开始时间）
      const startDate = new Date(now);
      startDate.setMonth(startDate.getMonth() - 6);

      const startStr = formatDate(startDate);
      const endStr = formatDate(endDate);

      // 赋值给日期范围
      this.filter.dateRange = [startStr, endStr];
    },
    handleInput(val) {
      // 只保留数字
      let value = val.replace(/[^\d]/g, "")
      if (value && value.length > 0) {
        // 转数字
        value = Number(value)
        // 限制范围
        if (value > 15) value = 15
        if (value < 0 || isNaN(value)) value = 0
        // 赋值
        this.filter.gunNo = value
      } else {
        this.filter.gunNo = ""
      }
    },
    // 格式化电量（除以1000）
    formatElect(value) {
      if (value === undefined || value === null) return "0.00"
      const numValue = parseFloat(value)
      if (isNaN(numValue)) return "0.00"
      return (numValue / 1000).toFixed(3)
    },

    // 格式化费用（除以10000）
    formatCost(value) {
      if (value === undefined || value === null) return "0.00"
      const numValue = parseFloat(value)
      if (isNaN(numValue)) return "0.00"
      return (numValue / 10000).toFixed(4)
    },

    // 处理数据单位转换
    processRecord(record) {
      if (!record) return record

      // 深拷贝一份数据，避免修改原始数据
      const processed = { ...record }

      // 1. 电量相关字段除以1000（单位：千瓦时→度）
      const electricityFields = ["totalElect", "sharpElect", "peakElect", "flatElect", "valleyElect", "sumStart", "sumEnd"]

      electricityFields.forEach((field) => {
        if (processed[field] !== undefined && processed[field] !== null) {
          const value = parseFloat(processed[field])
          if (!isNaN(value)) {
            // 除以1000，保留2位小数
            processed[`${field}Formatted`] = (value / 1000).toFixed(4)
          } else {
            processed[`${field}Formatted`] = "0.00"
          }
        } else {
          processed[`${field}Formatted`] = "0.00"
        }
      })

      // 2. 电费相关字段除以10000（单位：分→元）
      const costFields = ["totalPowerCost", "totalServCost", "sharpPowerCost", "peakPowerCost", "flatPowerCost", "valleyPowerCost", "sharpServCost", "peakServCost", "flatServCost", "valleyServCost"]

      costFields.forEach((field) => {
        if (processed[field] !== undefined && processed[field] !== null) {
          const value = parseFloat(processed[field])
          if (!isNaN(value)) {
            // 除以10000，保留2位小数
            processed[`${field}Formatted`] = (value / 10000).toFixed(4)
          } else {
            processed[`${field}Formatted`] = "0.00"
          }
        } else {
          processed[`${field}Formatted`] = "0.00"
        }
      })

      // 3. 转换计量计费类型
      if (processed.timeDivType !== undefined && processed.timeDivType !== null) {
        switch (processed.timeDivType) {
          case 10:
            processed.timeDivTypeText = "计费"
            break
          case 11:
            processed.timeDivTypeText = "计量"
            break
          case 12:
            processed.timeDivTypeText = "无计量计费"
            break
          default:
            processed.timeDivTypeText = `未知(${processed.timeDivType})`
        }
      } else {
        processed.timeDivTypeText = ""
      }

      return processed
    },

    onDetail(row) {
      // 处理数据后再显示详情
      this.detailForm = this.processRecord({ ...row })
      this.detailVisible = true
      console.log("ddddddddd", row)
      // 获取电量电费数据
      if (row) {
        this.detailForm.electricityData = {
          // 尖
          sharpElect: row.sharpElect || 0,
          sharpPowerCost: row.sharpPowerCost || 0,
          sharpServCost: row.sharpServCost || 0,
          // 峰
          peakElect: row.peakElect || 0,
          peakPowerCost: row.peakPowerCost || 0,
          peakServCost: row.peakServCost || 0,
          // 平
          flatElect: row.flatElect || 0,
          flatPowerCost: row.flatPowerCost || 0,
          flatServCost: row.flatServCost || 0,
          // 谷
          valleyElect: row.valleyElect || 0,
          valleyPowerCost: row.valleyPowerCost || 0,
          valleyServCost: row.valleyServCost || 0,
          // 总计
          totalElect: row.totalElect || 0,
          totalPowerCost: row.totalPowerCost || 0,
          totalServCost: row.totalServCost || 0,
          // 其他信息
          timeDivType: row.timeDivType,
          sumStart: row.sumStart,
          sumEnd: row.sumEnd
        }
      } else {
        this.detailForm.electricityData = null
      }
    },

    editPowerCurve(row) {
      this.modelParams = {
        asset_code: row.asset_code,
        ordernum: row.tradeNo,
        gun_no: row.gunNo,
        re_dev_type: "费控表",
        charge_start_time: row.charge_start_time,
        charge_end_time: row.charge_end_time
      }
      this.visible.curve = true
    },

    confirmpowercurve(item) {
      this.visible.curve = false
      this.detailForm.asset_code = item.asset_code
    },
    getReqData() {
      return {
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        name: this.filter.groupName || null,
        start_time: (this.filter.dateRange && this.filter.dateRange.length) ? this.filter.dateRange[0] : "",
        end_time: (this.filter.dateRange && this.filter.dateRange.length) ? this.filter.dateRange[1] : "",
        assets_code: this.filter.assets_code || null,
        tradeNo: this.filter.tradeNo || null,
        branch_box_name: this.filter.branch_box_name,
        site_name: this.filter.site_name,
        gunNo: this.filter.gunNo || null
      }
    },
    getDataStaticInfo() {
      GetDevUseElecStatisticInfo(this.getReqData())
        .then((res) => {
          if (res.data) {
            this.dataStaticInfo = res.data
          } else {
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getData() {
      this.loading = true
      this.getDataStaticInfo()
      getDevUseElecPageList(this.getReqData())
        .then((res) => {
          if (res.data && Array.isArray(res.data)) {
            // 处理每一条记录的单位转换
            this.tableData = res.data.map((item) => this.processRecord(item))
            console.log("处理后的表格数据:", this.tableData)
          } else {
            this.tableData = []
          }
          this.pageParams.total = res.total || 0
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}

/* 去除详情对话框的内外边距 */

/* 确保表格容器没有额外间距 */
.my-pagination {
  margin-top: 20px;
  text-align: right;
}

/* 尖峰平谷表格样式 */
.electricity-table-container {
  margin-top: 10px;
  padding: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #f8f9fa;
}

.electricity-table-container h3 {
  text-align: center;
  font-weight: bold;
  padding-bottom: 10px;
  border-bottom: 2px solid #409eff;
}
</style>
